module.exports = __webpack_public_path__ + "static/media/vertex_figure_polytope_5_52_5.01e64035.png";